













































































import {Component, Provide, Vue} from 'vue-property-decorator';
import Paginition from '@/components/Paginition.vue';
import FilterMenu from '@/components/FilterMenu.vue';
import EmailConfig from '@/models/emailconfig';

import {API} from '@/services/api/api';
import {mapActions} from 'vuex';

import {Filter} from '@/utils/Filter';

import {Utils} from '@/utils/Utils';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  components: {
    Paginition,
    FilterMenu,
  },
})
export default class EmailConfigList extends Vue {
  //header filter(true false for showing filter menu)
  header = [
    {
      value: 'senderName',
      name: 'Sender Name',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'subjectLine',
      name: 'Subject Title',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'configurationFor',
      name: 'Configuration For',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'createdDate',
      name: 'Created',
      headerType: 'date',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'edit',
      name: 'Edit',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
  ];

  emailConfigList: EmailConfig[] = [];

  filteredEmailConfigList: EmailConfig[] = this.emailConfigList;
  startingPoint = 0; //pagination starting point
  endingPoint = 5; //pagination ending point
  curentSort = ''; //current sort on which header

  //Store Variable
  showSuccessToast: any;
  showErrorToast: any;

  //Modal & Loader Variable
  isScreenLoading = true;
  loadingBtnStatus = false;
  asdcOrder = true;

  mounted() {
    this.getEmailConfigList();
  }

  async getEmailConfigList() {
    try {
      let response = await API.getEmailConfigList();
      this.isScreenLoading = false;
      if (response.data !== '' && response.data !== null) {
        let list: EmailConfig[] = response.data;
        this.emailConfigList = list;
        this.filteredEmailConfigList = list;
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  //sorting list
  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.filteredEmailConfigList);
    this.asdcOrder = sorted;
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number) {
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }
  // format date to human readable string
  formatDate(originalDate: string) {
    let formattedDate = Utils.formatDate(originalDate);
    return formattedDate;
  }

  //filter data based upon string parameters
  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.emailConfigList);
    this.filteredEmailConfigList = filteredData;
    this.resetPagination();
  }

  //filter data based upon date parameters
  filterOnDate(emittedFilterParams: any) {
    let filteredData = Filter.filterOnDateData(emittedFilterParams, this.emailConfigList);
    this.filteredEmailConfigList = filteredData;
    this.resetPagination();
  }

  //reset all filters and show current list of data
  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) {
      this.filteredEmailConfigList = this.emailConfigList;
      this.resetPagination();
    }
  }

  //show delete confirmation  modal

  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  public onEditClick(emailConfigId: number) {
    this.$router.push({path: '/edit-email-config/' + emailConfigId});
  }

  onSubmitClick() {
    this.$router.push({path: '/create-email-config'});
  }
}
